import DOMPurify from "dompurify";

/**
 * SafeHtml — render untrusted/third-party HTML (e.g. Aroflo job & quote
 * descriptions) with XSS protection. Always sanitizes via DOMPurify before
 * injecting, so any future HTML rendering is safe by default.
 *
 * Usage: <SafeHtml html={record.description} className="prose prose-sm" />
 */
export default function SafeHtml({ html, className = "", ...props }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} {...props} />;
}
